import md5 from 'blueimp-md5';
import { PARAMS_SIGN_KEY } from './config/index';
/**
 * base64加密
 * @param input
 * @returns {string}
 */

export function encodeBase64(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
}
/**
 * base64解密
 * @param input
 * @returns {string}
 */

export function decodeBase64(base64str) {
  return decodeURIComponent(escape(window.atob(base64str)));
}
/**
 * 获取请求参数签名
 * @param paramsObj
 */

export function getParamsSign() {
  var paramsObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var timestamp = Date.now();
  var sortParams = '';
  Object.keys(paramsObj).sort().forEach(function (key) {
    if (paramsObj[key] !== undefined && paramsObj[key] !== null) {
      sortParams += "".concat(key, "=").concat(paramsObj[key], "&");
    }
  });
  sortParams += "timestamp=".concat(timestamp, "&sign_key=").concat(PARAMS_SIGN_KEY);
  var sign = md5(sortParams).toLowerCase() + ' ' + timestamp;
  return sign;
}
/**
 * md5加密
 */

export { md5 };